/* eslint-disable no-unused-vars */
import React, { useState, useRef } from "react";
import "./App.css";
import Inputs from "./Inputs";
import Buttons from "./Buttons";
import Results from "./Results";
import Comments from "./Comments"
import { maxDigits, maxPrimes, commentsId } from "./constants";
import fetchComments from "./functions/fetchComments";

const loadComments = async (setComments, setCommentsVisible) => {
  const comments = await fetchComments(commentsId)
  setCommentsVisible(true)
  setComments(comments)
}

function App() {
  const [z, setZ] = useState(0);
  const [results, setResults] = useState([])
  const [count, setCount] = useState(1)
  const [app, rev] = document.title.split(",");
  const [commentsVisible, setCommentsVisible] = useState(false)
  const [comments, setComments] = useState([])

  const popup = () => {
    let popup = document.getElementById("infoPopup");
    popup.classList.toggle("show");
  }

  const showComments = () => {
    loadComments(setComments, setCommentsVisible)
  }

  const content = <div><span style={{ color: "black" }}>{rev}</span><p>Primes are determined by a 20-round <a href="https://en.wikipedia.org/wiki/Miller%E2%80%93Rabin_primality_test">Miller-Rabin primality test</a>&nbsp;
    with random bases that virtually eliminates the possibility of a false prime being returned.</p> </div>

  return (
    <div className="App">
      <h1 className="App-header">{app}</h1>
      <div id="credits">by Patrick and Jeff Lowery&nbsp;
        <div className="popup" onClick={popup}>&#9432;<span className="popuptext" id="infoPopup">{content}</span></div></div>
      <div id="explain">
        <p>This application is capable of generating up to {maxPrimes} consecutive primes of {maxDigits} digits or less.</p>
        <p>To start, enter an N value ending in a digit of 1, 3, 7, or 9 (or optionally generate a random N value of a specified number of digits).
          This will be the starting point for the prime number search.
        </p>
        <p>
          You can generate up to {maxPrimes} primes at a time. Total calculation time refers to the time spent to find all the primes requested,
          but does not factor in network lag or time to update the list of primes displayed.</p>
      </div>
      <div className="row">
        <input className="button-18" type="button" value="Comments" style={{ fontSize: "smaller", marginLeft: "3em" }} onClick={showComments}></input>
      </div>
      <hr></hr>
      {commentsVisible && <Comments {...{ comments, setCommentsVisible }} />
      }
      {!commentsVisible && <div id="mainApp">
        <Inputs
          {...{
            z, setZ, count, setCount,
          }}
        />
        <Buttons {...{ z, count, setResults }} />
        <hr></hr>
        <Results {...{ results }} />
      </div>}
    </div>
  );
}

export default App;
